/**
 * Parse through LocationCard.structure.ts and get all of the font family
 * inside of labels in order to import the custom fonts.
 * Looping through all the fonts, use addition conditional to combine
 * all the imports with custom font urls in one string, then rendering it
 * inside of a customGlobalStyle. The styled component is located in preview.js
 */

import { DynamicStructureType } from "../types";

export function getGoogleFonts(dynamicStructure: DynamicStructureType) {
  const customFontRegex = /[^",]+/;

  const fontFamilies = Object.keys(dynamicStructure.labels)
    .filter((key) => Boolean(dynamicStructure.labels[key]?.styles?.fontFamily))
    .reduce<Array<string>>((accu, curr) => {
      const fontFamily = dynamicStructure.labels[curr]?.styles?.fontFamily;
      // Get custom font, without san-serif or serif option
      const customFonts = fontFamily?.match(customFontRegex) || [];

      return [...accu, customFonts[0]];
    }, []);

  const fontWeights = Object.keys(dynamicStructure.labels)
    .filter((key) => Boolean(dynamicStructure.labels[key]?.styles?.fontWeight))
    .reduce<Array<number>>(
      (accu, curr) => [
        ...accu,
        dynamicStructure.labels[curr]?.styles?.fontWeight as number,
      ],
      [],
    );

  return fontFamilies.map((fontFamily) =>
    fontWeights.reduce<Array<string>>((accu, weight) => {
      const fontWithoutChar = fontFamily
        .split(` `)
        .join(`+`)
        .replace(`'`, ``)
        .replace(`'`, ``);

      return [
        ...accu,
        `https://fonts.googleapis.com/css2?family=${fontWithoutChar}:wght@${weight}&display=swap`,
      ];
    }, []),
  );
}
